<template>
  <!-- 对话框 -->
  <el-dialog :visible.sync="show" :before-close="closeDialog" width="70%">

    <!-- 基本信息表单 -->
    <div class="form-box">


      <el-form ref="form" label-width="80px" style="overflow-y: auto; height: 65vh;">

        
        <div style="display: flex;">


          <el-form-item label="司机手机号:" label-width='100px'>

            <el-input v-model="phone" style="width: 150px;margin-right: 5px;" maxlength=11></el-input>
            <el-button @click="addDriver">添加</el-button>

          </el-form-item>
          <el-form-item label="已绑定手机号:" label-width='100px' style="margin-left:10px">

            <el-input v-model="search_data_children.phone" style="width: 150px;margin-right: 5px;" maxlength=11></el-input>
            <el-button type="primary"  @click="searchGetDriverList">搜索</el-button>

          </el-form-item>

        </div>


        <!-- 表格 -->
        <el-table :data="tableData" style="width: 100%" height="50vh" ref="multipleTable"
                  header-cell-class-name="table-header">



          <el-table-column prop="driver_name" label="司机名称">
          </el-table-column>

          <el-table-column prop="phone" label="司机电话">
          </el-table-column>

          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button @click="delDriver(scope.row.phone)" type="danger">删除指定司机</el-button>
            </template>
          </el-table-column>


        </el-table>

        <div class="pagination">

          <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="pages_function"
                  :current-page="search_data_children.page"
                  :page-sizes="[10, 20, 30, 40 ,50]"
                  :page-size="search_data_children.limit"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="result_data_children.count">
          </el-pagination>

        </div>



      </el-form>

      <!-- 对话框底部按钮 -->
      <div style="display: flex;justify-content: center">

        <el-button @click="closeDialog">关闭</el-button>
      </div>

    </div>

  </el-dialog>
</template>

<script>
  var _this;
  export default {
    props: {
      'isShow': Boolean,
      'data':''
    },
    components: {

    },
    watch: {

      isShow(newData, oldData) {

        _this.show = true;

        _this.search_data_children.appid = _this.data;

        _this.getDriverList();

      },

    },
    data() {
      return {
        show: false,

        phone:'',

        tableData: [],



        //翻页数据
        search_data_children: {
          page:1,
          limit:10,
          appid:'',
          phone: ''
        },

        result_data_children:[]


      };
    },
    created() {

      _this = this;

    },
    methods: {
      searchGetDriverList() {
        _this.search_data_children.page = 1;
        _this.getDriverList();


      },
      //页码值改变
      pages_function(search_data) {
   
        //赋值
        _this.search_data_children.page = search_data;

        console.log(_this.search_data_children.page);

        //初始化列表
        _this.getDriverList();
      },

      //下拉条（每页显示多少数据）变化
      handleSizeChange(val) {

        console.log(val);

        _this.search_data_children.limit = val;

        _this.getDriverList();

      },

      delDriver(phone){
        _this.$post(
                '/cooperator/delDriver',{
                  appid:_this.data,
                  phone:phone
                }
        ).then(res => {

          _this.getDriverList();


        }).catch((err) => {

        });
      },
      addDriver(){
        _this.$post(
              '/cooperator/addDriver',{
                appid:_this.data,
                phone:_this.phone
              }
        ).then(res => {

          _this.getDriverList();


        }).catch((err) => {

        });

      },

      getDriverList(){



          _this.$post(
                  '/cooperator/getDriverList',
                  _this.search_data_children
          ).then(res => {

            _this.tableData = res.data;
            _this.result_data_children = res;

          }).catch((err) => {

          });


      },


      // 关闭方法
      closeDialog() {

        _this.show = false;
        _this.search_data_children.phone = '';

        _this.phone = '';

        _this.tableData = [];
         _this.search_data_children= {
          page:1,
          limit:10,
          appid:'',
          phone: ''
        },

        _this.$emit('onSubmit')

      }


    }
  };
</script>

<style scoped>
  .form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

  .el-form-second {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }

  .avatar-uploader {
    width: 100px;
    height: 100px;
  }
</style>
